import React from 'react';
import JobSkills from './JobSkills';

interface Skill {
  id: string | number;
  name: string;
  category: string;
  color: string;
}

interface JobData {
  position_type?: string;
  skills?: Skill[];
  temp_date?: string;
  benefit_medical?: boolean;
  benefit_dental?: boolean;
  benefit_vision?: boolean;
  benefit_401k?: boolean;
  benefit_pto?: boolean;
  benefit_bonuses?: boolean;
}

interface JobTagsProps {
  job: JobData;
  className?: string;
}

/**
 * JobTags component - displays skills and other job-related tags
 * Migrated from original JobTags component with improved TypeScript support
 */
export default function JobTags({ job }: JobTagsProps) {
  if (job.skills === undefined) {
    return null;
  }

  return (
    <JobSkills
      job={job}
      skills={job.skills}
    />
  );
}
